export default __webpack_public_path__ + "static/media/lanceroClosed.0cec8e91.jpg";